import React from 'react';
import { Router, Route, Switch } from 'dva/router';
import './App.less';
import PageLoading from './components/PageLoading';


// Containers
const DefaultLayout = React.lazy(() => import('./containers/DefaultLayout'));
const UserLayout = React.lazy(() => import('./containers/DefaultLayout/UserLayout'));
var consoleHolder = console;
function debug(bool) {
  if (!bool) {
    consoleHolder = console;
    console = {};
    Object.keys(consoleHolder).forEach(function (key) {
      console[key] = function () { };
    });
  } else {
    console = consoleHolder;
  }
}
if (process.env.NODE_ENV == 'production') {
  debug(false);
} else {
  debug(true);
}

// Pages
// const Register = React.lazy(() => import('./views/Pages/Register'));
const Page404 = React.lazy(() => import('./views/Pages/Page404'));
const Page500 = React.lazy(() => import('./views/Pages/Page500'));

export default ({ history, app }: { history: any, app: any }) => {
  return (
    <Router history={history}>
      <React.Suspense fallback={<PageLoading />}>
        <Switch>
          <Route exact path="/login" name="Login Page" render={props => <UserLayout {...props} />} />
          {/* <Route exact path="/register" name="Register Page" render={props => <Register {...props} />} /> */}
          <Route exact path="/exception/404" name="Page 404" render={props => <Page404 {...props} />} />
          <Route exact path="/exception/500" name="Page 500" render={props => <Page500 {...props} />} />
          <Route path="/" name="Home" render={props => <DefaultLayout {...props} />} />
        </Switch>
      </React.Suspense>
    </Router>
  );
}
